module.exports = __webpack_public_path__ + "static/media/ubatuba-sp.54f0d71d.jpg";